import axios from 'axios';

var token =  window.sessionStorage.getItem('token')
//console.log('axios'+token);
export const HTTP = axios.create({
  
  baseURL: process.env.HOST_API,
  authorization: `Bearer ${token}`
  
 
})
HTTP.defaults.headers.common['authorization'] = `Bearer ${token}`;
axios.interceptors.response.use(undefined, function (err) {

  console.log('errr axios'+err)
});


// WEBPACK FOOTER //
// ./src/services/http.axios.js